import React from "react";

const Input = ({ placeholder, value, onChange, className }) => {
    return (
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className={`border rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 ${className}`}
      />
    );
  };

  const Button = ({ children, onClick, className }) => {
    return (
      <button
        onClick={onClick}
        className={`bg-blue-500 hover:bg-blue-600 text-white font-medium py-2 px-4 rounded-lg transition duration-300 ${className}`}
      >
        {children}
      </button>
    );
  };
  
  const Card = ({ children, className }) => {
    return (
      <div className={`border shadow-lg rounded-lg p-4 ${className}`}>
        {children}
      </div>
    );
  };
  

  const Checkbox = ({ children, checked, onChange, className }) => {
    return (
      <label className={`flex items-center space-x-2 ${className}`}>
        <input
          type="checkbox"
          checked={checked}
          onChange={onChange}
          className="h-5 w-5 text-blue-500 border-gray-300 rounded focus:ring-blue-500"
        />
        <span className="text-gray-700">{children}</span>
      </label>
    );
  };

const Slider = ({ value, onChange, range, className }) => {
  return (
    <input
      type="range"
      min={range ? range[0] : 0}
      max={range ? range[1] : 100}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={`appearance-none w-full h-2 bg-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 ${className}`}
    />
  );
};


export { Input, Button, Card, Checkbox, Slider };



  
  